import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { Input } from '@components/Input';

const ADORNMENT_PADDING = 14;

const SIZES = {
    medium: { icon: 20, iconGap: 8, labelTop: 12 },
    small: { icon: 16, iconGap: 4, labelTop: 8, inputPadding: '8px 8px 8px 0 !important' },
};

const StyledInput = styled(Input, { shouldForwardProp: prop => prop !== 'size' })(({ size }) => {
    const { icon, iconGap, labelTop, inputPadding } = SIZES[size];
    return {
        ...(inputPadding && { '& input': { padding: inputPadding } }),
        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
            transform: `translate(${ADORNMENT_PADDING + icon + iconGap}px, ${labelTop}px) scale(1)`,
        },
        '& .MuiSvgIcon-root': {
            width: icon,
            height: icon,
            marginRight: iconGap,
        },
    };
});

export const SearchInput = ({ value, onChange, label, className, size = 'medium' }) => (
    <StyledInput
        className={className}
        size={size}
        label={label}
        inputProps={{ value, onChange: e => onChange(e.target.value) }}
        startAdornment={<SearchIcon />}
    />
);
